package com.clany.backoffice.model

import kotlinx.serialization.Serializable

@Serializable
data class UserResponse(
    val id: String,
    val username: String,
    val email: String,
    val firstName: String,
    val lastName: String,
    val linkedMemberId: String? = null,
    val createdAt: String,
    val updatedAt: String,
    val type: UserType = UserType.FREE,
    val status: UserStatus = UserStatus.ACTIVE,
    val authProvider: UserAuthProvider = UserAuthProvider.EMAIL,
    val locale: String,
    val externalId: String? = null,
    val pictureUrl: String? = null,
    val lastActiveAt: String? = null,
    val shouldUpdateTyc: Boolean = false,
    val isAnonymized: Boolean = false,
    val lastTycNotification: String? = null,
    val deviceTokens: List<DeviceTokenResponse> = emptyList(),
    val acceptedTerms: List<AcceptedTerm> = emptyList(),
    val tycUpdateInfo: TycUpdateInfo? = null
)

@Serializable
data class DeviceTokenResponse(
    val notificationToken: String = "",
    val platform: String = "",
)